import {
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  styled,
  IconButton,
  Fade,
  FormControl,
  Select,
  FormHelperText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  InputLabel,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PendingIcon from "@mui/icons-material/Pending";

export const MainContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  rowGap: 40,
  flexDirection: "column",
  padding: "0.5rem 1rem 1rem 1rem",

  [theme.breakpoints.between("sm", "md")]: {
    padding: 0,
  },
}));

// User List -- Start

export const SearchInput = styled((props) => (
  <TextField
    InputProps={
      {
        // disableUnderline: true
      }
    }
    {...props}
  />
))(({ theme }) => ({
  fontWeight: 500,
  fontSize: "0.8rem",
  width: "100%",
  "& .MuiInputLabel-root": {
    color: "#000000",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#4A4F55",
  },

  "& .MuiInput-underline": {
    "&:before": {
      borderBottomColor: "#C1C5C8",
    },
    "&:hover:not(.Mui-disabled):before": {
      borderBottomColor: "black",
    },
    "&:after": {
      borderBottomColor: "black",
    },
  },
}));

export const AddNewUser = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "1rem",
  color: "#005078",
  display: "inline-block",
  textTransform: "none",
}));

export const AddUserBox = styled(Grid)(({ theme }) => ({
  borderBottom: "0.06rem solid #EFEFEF",
  borderTop: "0.06rem solid #EFEFEF",
  // padding: "0.7rem",

  [theme.breakpoints.between("sm", "md")]: {
    // padding: "0.6rem 0 0.6rem 0",
  },
}));

export const AddUserOnClickBox = styled(Button)({
  display: "inline-block",
});

export const SearchButton = styled(Button)({
  width: "100%",
  height: "100%",
});

export const AddUserSubBox = styled(Box)(({ theme }) => ({
  display: "flex",
  columnGap: 5,

  [theme.breakpoints.between("sm", "md")]: {
    columnGap: 3,
  },
}));

export const SearchBox = styled(Grid)(({ theme }) => ({
  display: "flex",
  // columnGap: 15,
  width: "100%",

  [theme.breakpoints.between("sm", "md")]: {
    flexDirection: "column",
    rowGap: 5,
  },
}));

export const NoUserBox = styled(Grid)(({ theme }) => ({
  display: "flex",
  width: "100%",
  justifyContent: "center",
}));

export const LoadingBox = styled(Grid)(({ theme }) => ({
  display: "flex",
  width: "100%",
  justifyContent: "center",
  height: "100px",
  alignItems: "center",
}));

export const NoUserMessage = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: "1rem",

  [theme.breakpoints.between("sm", "md")]: {
    fontSize: "0.9rem",
  },
}));

export const UserListContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  rowGap: 40,
});

export const UserContainer = styled(Grid)({
  display: "flex",
  rowGap: 20,
  flexDirection: "column",
});

export const UserBox = styled(Grid)(({ theme, open, index }) => ({
  border: "0.1rem solid #B9D9EB",
  borderRadius: 7,
  padding: 20,
  display: "flex",
  columnGap: 25,
  // position: "relative",
  width: "100%",
  [theme.breakpoints.between("sm", "stm")]: {
    padding: 12,
  },

  [theme.breakpoints.between("sm", "md")]: {
    ...(open === index && {
      borderBottomWidth: "0px",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    }),
  },
}));

export const UserDetailsBox = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  rowGap: 7,
  justifyContent: "center",

  [theme.breakpoints.between("sm", "stm")]: {
    rowGap: 7,
  },
}));

export const UserAccessDetailsBox = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  rowGap: 7,

  [theme.breakpoints.between("sm", "stm")]: {
    rowGap: 5,
  },
}));

export const UserAccessSubBox = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  columnGap: 5,
  alignItems: "center",

  [theme.breakpoints.between("sm", "stm")]: {
    columnGap: 2,
  },
}));

export const UserEditBox = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "row-reverse",
}));

export const UserName = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "1.2rem",
  width: "100%",
  // whiteSpace:"break-spaces",
  // wordWrap:"break-word",
  overflowWrap: "break-word",
  [theme.breakpoints.between("sm", "stm")]: {
    fontSize: "0.85rem",
  },

  [theme.breakpoints.between("stm", "mtl")]: {
    fontSize: "1.1rem",
  },
}));

export const UserType = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "0.8rem",
  color: "#00778F",

  [theme.breakpoints.between("sm", "stm")]: {
    fontSize: "0.75rem",
  },

  [theme.breakpoints.between("stm", "mtl")]: {
    fontSize: "0.8rem",
  },
}));

export const UserAccess = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: "0.9rem",
  color: "#000000",

  [theme.breakpoints.between("sm", "stm")]: {
    fontSize: "0.67rem",
  },

  [theme.breakpoints.between("stm", "md")]: {
    fontSize: "0.8rem",
  },

  [theme.breakpoints.between("md", "mtl")]: {
    fontSize: "0.8rem",
  },
}));

// View Icons

export const ButtonBox = styled(IconButton)(({ theme }) => ({
  "&:hover": {
    backgroundColor: "white",
  },
}));

export const AddUserArrow = styled(KeyboardArrowDownIcon)({
  color: "#005078",
});

export const UserEditIcon = styled((props) => <EditIcon {...props} />)(
  ({ theme, open, index }) => ({
    color: "#005078",
    position: "absolute",
    margin: "5px",
    "&:hover": {
      fontSize: "1.7rem",
      color: "#005078",
    },

    [theme.breakpoints.between("sm", "stm")]: {
      fontSize: "1.2rem",
      // right: 10,
    },

    ...(open === index && {
      color: "black",
      "&:hover": {
        fontSize: "1.7rem",
        color: "black",
      },

      [theme.breakpoints.between("sm", "stm")]: {
        fontSize: "1.2rem",
        // right: 10,
      },
    }),
  })
);

export const UserAccessCheckIcon = styled(CheckIcon)(({ theme }) => ({
  color: "#4b4f54",
  fontSize: "medium",

  [theme.breakpoints.between("sm", "stm")]: {
    fontSize: "0.7rem",
  },

  [theme.breakpoints.between("stm", "md")]: {
    fontSize: "small",
  },
}));

export const UserPendingIcon = styled(PendingIcon)(({ theme }) => ({
  color: "#4b4f54",
  fontSize: "large",

  [theme.breakpoints.between("sm", "md")]: {
    fontSize: "0.8rem",
  },
}));

export const SearchLoadingIcon = styled(CircularProgress)(({ theme }) => ({
  color: "white",
}));

// User List View -- End

/////////////////////////////////////////////////////

// User Update -- start

export const UpdateFadeBox = styled((props) => <Fade {...props} />)(
  ({ theme, styles, isMobile }) => ({
    ...(!isMobile && { width: `${styles}px` }),
    ...(isMobile && { width: `100%` }),
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
  })
);

export const ArrowBox = styled(Box)(({ theme, isMobile }) => ({
  ...(!isMobile && {
    position: "absolute",
    top: "0%",
    left: "105%",
    borderRadius: "5px",
    border: "1px solid #EFEFEF",
    padding: "20px",
  }),

  ...(isMobile && {
    border: "1px solid #B9D9EB",
    borderTopWidth: "0px",
    padding: "15px",
    overflowY: "scroll",
    scrollBehavior: "smooth",
  }),

  maxWidth: "100%",
  backgroundColor: "#F5F5F5",
  paddingTop: "25px",
  paddingBottom: "25px",
  borderBottomLeftRadius: "5px",
  borderBottomRightRadius: "5px",
  wordWrap: "normal",
}));

export const Arrow = styled((props) => <Box {...props} />)(
  ({ theme, isMobile, height }) => ({
    ...(!isMobile && {
      top: "2.4rem",
      left: "-10px",
      borderWidth: "10px 10px 10px 0px",
      borderColor: "transparent #F5F5F5 transparent transparent",
    }),
    ...(isMobile && {
      bottom: `${height}px`,
      right: "15px",
      borderWidth: "0px 10px 10px 10px",
      borderColor: "transparent transparent #F5F5F5 transparent",
    }),
    width: 0,
    height: 0,
    borderStyle: "solid",
    position: "absolute",
    zIndex: 100,
  })
);

export const ArrowBorder = styled((props) => <Box {...props} />)(
  ({ theme, isMobile, height }) => ({
    ...(!isMobile && {
      top: "2.34rem",
      left: "-11px",
      borderWidth: "11px 11px 11px 0px",
      borderColor: "transparent #EFEFEF transparent transparent",
      zIndex: 10,
    }),
    ...(isMobile && {
      borderWidth: "0px 0px 0px 0px",
      borderColor: "transparent transparent transparent transparent",
      zIndex: -100000,
    }),
    position: "absolute",
    width: 0,
    height: 0,
    borderStyle: "solid",
  })
);

export const UpdateUserBox = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  rowGap: 60,
}));

export const UpdateUserMainBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  // width: "280px",
  width: "90%",
  rowGap: "25px",

  [theme.breakpoints.between("sm", "mtl")]: {
    width: "100%",
  },

  [theme.breakpoints.between("lg", "xl")]: {
    width: "85%",
  },
}));

export const UpdateTextField = styled((props) => (
  <TextField
    InputProps={
      {
        // disableUnderline: true
      }
    }
    {...props}
  />
))(({ theme }) => ({
  fontWeight: 500,
  width: "100%",
  color: "black",
  input: {
    fontSize: "1rem",
  },
  "& .MuiInputLabel-root": {
    color: "#4A4F55",
    fontWeight: 400,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#4A4F55",
  },

  "& .MuiInput-underline": {
    "&:before": {
      borderBottomColor: "#C1C5C8",
    },
    "&:hover:not(.Mui-disabled):before": {
      borderBottomColor: "black",
    },
    "&:after": {
      borderBottomColor: "black",
    },
  },

  "& .MuiInputBase-root": {
    "&.Mui-disabled:before": {
      borderBottomStyle: "solid",
    },
    "&.Mui-disabled:after": {
      borderBottomStyle: "solid",
    },
  },

  [theme.breakpoints.between("sm", "md")]: {
    input: {
      fontSize: "0.9rem",
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.8rem",
      fontWeight: 400,
    },
  },
}));

export const UpdateSelectBox = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
}));

export const UpdateSelectTag = styled(Typography)(({ theme }) => ({
  fontSize: "0.75rem",
  fontWeight: 400,
  lineHeight: "1.125rem",
  color: "#4A4F55",

  [theme.breakpoints.between("sm", "md")]: {
    fontSize: "0.6rem",
  },
}));

export const UpdateSelect = styled(Select)(({ theme }) => ({
  width: "100%",
  "&::before": {
    borderBottom: "1px solid #C1C5C8",
  },
  "&::after": {
    borderBottom: "1px solid black",
  },

  "& .MuiSelect-select": {
    fontSize: "0.95rem",
  },

  [theme.breakpoints.between("sm", "md")]: {
    "& .MuiSelect-select": {
      fontSize: "0.9rem",
    },
  },
}));

export const UpdateButtonBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row-reverse",
  justifyContent: "space-between",
  columnGap: 50,

  [theme.breakpoints.between("sm", "mtl")]: {
    flexDirection: "column",
    justifyContent: "centre",
    rowGap: 10,
  },
}));

export const UpdateButton = styled(Button)(({ theme }) => ({
  width: "50%",
  borderRadius: "10px",
  fontFamily: "Open Sans",
  padding: "9px",
  fontWeight: 600,
  color: "#005078",
  boxShadow: "box-shadow: 0px 0px 15px 0px #00000026",
  [theme.breakpoints.between("sm", "mtl")]: {
    width: "100%",
  },
}));

export const ErrorMessageHelper = styled(FormHelperText)(({ theme }) => ({
  fontSize: "0.6rem",

  [theme.breakpoints.between("sm", "md")]: {
    fontSize: "0.53rem",
  },
}));

export const RemoveUserBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  rowGap: "40px",
}));

export const RemoveUserContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  rowGap: "15px",
}));

export const RemoveUserHeader = styled(Box)(({ theme }) => ({
  fontSize: "1rem",
  fontWeight: "600",

  [theme.breakpoints.between("sm", "md")]: {
    fontSize: "0.9rem",
  },
}));

export const RemoveUserPara = styled(Box)(({ theme }) => ({
  fontSize: "0.8rem",
  fontWeight: "400",

  [theme.breakpoints.between("sm", "md")]: {
    fontSize: "0.78rem",
  },
}));

export const AddUserContainer = styled(Accordion)(({ theme }) => ({
  boxShadow: "none",
  margin: "2px",
}));

export const AddUserHeader = styled(AccordionSummary)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  columnGap: "5px",
  padding: 0,
  "& .MuiAccordionSummary-content": {
    flexGrow: 0,
    fontSize: "1rem",
    fontWeight: 600,
    color: "#005078",
  },
}));

export const AddDetailsContainer = styled(AccordionDetails)(({ theme }) => ({
  padding: "0px",
  display: "flex",
  flexDirection: "column",
  margin: "10px 0 30px 0",
  rowGap: "50px",
}));

export const AddDetailsBox = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  padding: 0,
  columnGap: "35px",
  rowGap: "16px",

  [theme.breakpoints.between("md", "lg")]: {
    columnGap: "30px",
    rowGap: "16px",
  },

  [theme.breakpoints.between("sm", "md")]: {
    rowGap: "12px",
  },
}));

export const FormControlForSelect = styled(FormControl)(({ theme }) => ({
  width: "100%",
  position: "relative",
}));

export const SelectInputLabel = styled(InputLabel)(({ theme, length }) => ({
  position: "absolute",
  left: -14,
  top: 5,
  fontWeight: 400,
  fontSize: length === 0 ? "0.98rem" : "0.88rem",
  color: "#4A4F55",
  "&.Mui-focused": {
    color: "#4A4F55",
  },

  [theme.breakpoints.between("sm", "md")]: {
    top: 7,
    fontSize: "0.8rem",
  },
}));

export const AddButtonBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row-reverse",
  justifyContent: "space-between",
  columnGap: 50,

  [theme.breakpoints.between("sm", "md")]: {
    flexDirection: "column",
    justifyContent: "centre",
    rowGap: 10,
  },
}));

export const AddButton = styled(Button)(({ theme }) => ({
  width: "20%",
  borderRadius: "10px",
  fontFamily: "Open Sans",
  padding: "9px",
  fontWeight: 600,
  color: "white",
  boxShadow: "box-shadow: 0px 0px 15px 0px #00000026",
  [theme.breakpoints.between("sm", "md")]: {
    width: "100%",
  },
  [theme.breakpoints.between("md", "mtl")]: {
    width: "30%",
  },
}));
